var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isChatBot)?_c('FuncionalidadeCustomizadaChatBotComponent'):(_vm.isWebView)?_c('FuncionalidadeCustomizadaWebViewComponent'):(_vm.isSolicitacao)?_c('FuncionalidadeCustomizadaSolicitacaoComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }